document.addEventListener("DOMContentLoaded", function () {
    function toggleRows(rowId, buttonId) {
        let hiddenRows = document.getElementById(rowId);
        let button = document.getElementById(buttonId);

        if (hiddenRows.style.display === "none" || hiddenRows.style.display === "") {
            hiddenRows.style.display = "table-row-group"; // Show hidden rows
            button.textContent = "Show Less";
        } else {
            hiddenRows.style.display = "none"; // Hide rows
            button.textContent = "Show More";
        }
    }

    let toggleModelsButton = document.getElementById("toggle-models");
    let toggleCasesButton = document.getElementById("toggle-cases");

    if (toggleModelsButton) {
        toggleModelsButton.addEventListener("click", function () {
            toggleRows("hidden-model-rows", "toggle-models");
        });
    }

    if (toggleCasesButton) {
        toggleCasesButton.addEventListener("click", function () {
            toggleRows("hidden-case-rows", "toggle-cases");
        });
    }
});
